// extracted by mini-css-extract-plugin
export default {"wrapper":"layout-changer_wrapper__wFZXW","menuButton":"layout-changer_menuButton__3-m6e","menu":"layout-changer_menu__nbyn9"};